import React from "react";
import "./ThemeToggle.scss";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import { useTheme, THEMES } from "../../theme/ThemeProvider";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === THEMES.DARK;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`sp-theme-toggle ${isDark ? "is-dark" : "is-light"}`}
      aria-label={`Switch to ${isDark ? "light" : "dark"} theme`}
      title={`Switch to ${isDark ? "light" : "dark"} theme`}
    >
      <span className="sp-theme-toggle__thumb">
        {isDark ? <DarkModeIcon /> : <LightModeIcon />}
      </span>
    </button>
  );
};

export default ThemeToggle;
